import { z } from 'zod';

/**
 * A request that writes several operations (a grouped undo, a restore) stores
 * its id on the first and `<id>#<k>` on the k-th after it. Request ids may not
 * contain `#`, so no other request's id can look like one of those rows and a
 * retry can be matched to exactly the rows it wrote.
 */
const GROUP_MEMBER_SEPARATOR = '#';

export const ClientCommandIdSchema = z
  .string()
  .min(1)
  .refine((id) => !id.includes(GROUP_MEMBER_SEPARATOR), {
    message: `clientCommandId may not contain "${GROUP_MEMBER_SEPARATOR}"`,
  });

export function groupMemberCommandId(
  clientCommandId: string,
  index: number
): string {
  return index === 0
    ? clientCommandId
    : `${clientCommandId}${GROUP_MEMBER_SEPARATOR}${index}`;
}

/** What every row after the first of request `clientCommandId` starts with. */
export function groupMemberPrefix(clientCommandId: string): string {
  return `${clientCommandId}${GROUP_MEMBER_SEPARATOR}`;
}
